export default {
  IMPORT_VEHICLE_MODEL_FILE: 'IMPORT_VEHICLE_MODEL_FILE',
  IMPORT_VEHICLE_MODEL_FILE_SUCCESS: 'IMPORT_VEHICLE_MODEL_FILE_SUCCESS',
  CANCEL_IMPORT_VEHICLE_MODEL_FILE: 'CANCEL_IMPORT_VEHICLE_MODEL_FILE'
}
